import { LinearProgress, Box, Typography } from "@mui/material";
import LogoWithTitle from "../../../assests/logo.png";
import useMobileDetection from "../../../Hooks/useMobileDetection";

export default function InlineLoader({ message = "" }) {
  const isMobile = useMobileDetection();
  let loaderWidth = isMobile ? "120px" : "150px"; 

  return (
    <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center', 
        width: '100%',
        height: '100%',           
        minHeight: '75vh',        
        flexGrow: 1,
        gap: 2 
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <img 
          src={LogoWithTitle} 
          alt="Logo" 
          style={{ width: loaderWidth, height: 'auto' }} 
        />
      </Box>
      <Box sx={{ width: loaderWidth }}>
        <LinearProgress sx={{ height: 4, borderRadius: 2 }} />
      </Box>
      {message && (
        <Typography 
          variant="body1" 
          color="text.secondary" 
          sx={{ 
            textAlign: 'center',
            width: '100%',
            px: 2
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
}